import { render, staticRenderFns } from "./OverviewManagement.vue?vue&type=template&id=34436b9c&"
import script from "./OverviewManagement.vue?vue&type=script&lang=js&"
export * from "./OverviewManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports